"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionStage = exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["SWAP"] = "swap";
    ActionType["WRAP"] = "wrap";
    ActionType["BRIDGE"] = "bridge";
    ActionType["IBC_TRANSFER"] = "ibc-transfer";
    ActionType["CUSTOM"] = "custom";
})(ActionType || (exports.ActionType = ActionType = {}));
var ActionStage;
(function (ActionStage) {
    ActionStage[ActionStage["EVM_SOURCE"] = 0] = "EVM_SOURCE";
    ActionStage[ActionStage["EVM_DESTINATION"] = 1] = "EVM_DESTINATION";
    ActionStage[ActionStage["EVM_TRANSIENT"] = 2] = "EVM_TRANSIENT";
    ActionStage[ActionStage["EVM_ONLY"] = 3] = "EVM_ONLY";
    ActionStage[ActionStage["COSMOS_SOURCE"] = 4] = "COSMOS_SOURCE";
    ActionStage[ActionStage["COSMOS_DESTINATION"] = 5] = "COSMOS_DESTINATION";
    ActionStage[ActionStage["COSMOS_TRANSIENT"] = 6] = "COSMOS_TRANSIENT";
    ActionStage[ActionStage["COSMOS_ONLY"] = 7] = "COSMOS_ONLY";
})(ActionStage || (exports.ActionStage = ActionStage = {}));
//# sourceMappingURL=index.js.map